export const CREATE = 'CREATE'
export const READ = 'READ'
export const UPDATE = 'UPDATE'
export const DELETE = 'DELETE'

export const AUTH = 'AUTH'
export const LOGOUT = 'LOGOUT'